export default __webpack_public_path__ + "static/media/cd-icon-arrow-next.5c22149c.svg";